import http from 'conversations-http/clients/http';
export const moveToInbox = ({
  threadId,
  newInboxId
}) => {
  const url = `conversations-threads/v1/threads/${threadId}/update-inbox/${newInboxId}`;
  return http.put(url);
};